import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { NAV_ITEMS } from './navItems'

const BottomNav = () => {
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const { t } = useTranslation()

    const currentIndex = NAV_ITEMS.findIndex((item) => item.path === pathname)
    const value = currentIndex === -1 ? 0 : currentIndex

    return (
        <Paper
            elevation={0}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                borderTop: '1px solid rgba(0, 0, 0, 0.12)',
                zIndex: (theme) => theme.zIndex.appBar,
            }}
        >
            <BottomNavigation
                value={value}
                onChange={(_, newValue: number) => {
                    navigate(NAV_ITEMS[newValue].path)
                }}
            >
                {NAV_ITEMS.map((item) => {
                    const Icon = item.icon
                    return (
                        <BottomNavigationAction
                            key={item.path}
                            label={t(item.labelKey)}
                            icon={<Icon size={20} />}
                        />
                    )
                })}
            </BottomNavigation>
        </Paper>
    )
}

export default BottomNav
